import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Tooltip from '@mui/material/Tooltip'

const ParentButton = ({ menu_params, current_menu, Icono, small }) => {
  const listButton = (
    <ListItemButton
      key={current_menu.id}
      id={current_menu.id}
      {...menu_params}
      sx={{
        p: '4px',
        borderTopLeftRadius: '15px',
        borderBottomLeftRadius: '15px',
        pl: 2,
        pr: 1,
        ml: 1,
        fontWeight: '300',
      }}
    >
      <ListItemIcon sx={{ paddingLeft: '5px' }}>
        {Icono ? <Icono sx={{ color: 'background.menuContrast' }} /> : null}
      </ListItemIcon>
      {!small ? <ListItemText primary={current_menu.nombre} /> : ''}
    </ListItemButton>
  )

  if (current_menu.programa === 'mailto') {
    return (
      <Tooltip key={current_menu.id} title={current_menu.camino} placement="right">
        {listButton}
      </Tooltip>
    )
  } else {
    return listButton
  }
}

export default ParentButton
